import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=18ee5e48&"
import script from "./Demand.vue?vue&type=script&lang=js&"
export * from "./Demand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ee5e48')) {
      api.createRecord('18ee5e48', component.options)
    } else {
      api.reload('18ee5e48', component.options)
    }
    module.hot.accept("./Demand.vue?vue&type=template&id=18ee5e48&", function () {
      api.rerender('18ee5e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Aggregation/Demand.vue"
export default component.exports